const getFrontendCanSell = () => {
  const envValue = process.env.REACT_APP_CAN_SELL;
  
  
  if (envValue === 'true') {
    return true;
  }
  
  
  return false;
};

export const frontendConfig = {
  canSell: getFrontendCanSell(),
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001',
};

export const getFinalCanSellState = (backendCanSell = true) => {
  const frontendCanSell = frontendConfig.canSell;
  
  
  const finalState = frontendCanSell && backendCanSell;
  
  return finalState;
};







export const getDisabledReason = (backendCanSell = true) => {
  const frontendCanSell = frontendConfig.canSell;
  
  if (!frontendCanSell && !backendCanSell) {
    return 'Бронювання тимчасово відключено на рівні системи та сервера.';
  } else if (!frontendCanSell) {
    return 'Бронювання тимчасово відключено. Ви можете переглядати ціни та інформацію про ski паси.';
  } else if (!backendCanSell) {
    return 'Бронювання тимчасово недоступне на сервері. Спробуйте пізніше.';
  }
  
  return 'Бронювання доступне.';
};

export default frontendConfig;
